<template>
  <div id="merchant-passagewayList">
    <div class="table-container">
      <div class="table-filtrate">
        <ul>
          <li>
            <span class="label">输入关键字:</span>
            <el-input
              placeholder="请输入内容"
              v-model="filtrate.keyword"
              @keyup.enter.native="getList(1)"
            >
              <el-button
                slot="append"
                icon="el-icon-search"
                @click="getList(1)"
              ></el-button>
            </el-input>
          </li>
          <li>
            <el-button class="resetBtn" size="medium" @click="reset"
              >重置
            </el-button>
          </li>
        </ul>
        <ul>
          <li>
            <el-button
              class="addCoupon"
              type="primary"
              @click="$refs.actionDialog.show = true"
              v-if="
                buttonList.includes(
                  'parkingLotList-detail-merchantTab-detail-subListTab-add'
                )
              "
              ><i class="iconfont icon-jiahao"></i> 新增子账号
            </el-button>
          </li>
        </ul>
      </div>
      <el-table
        :data="table.tableData"
        style="width: 100%"
        v-loading="table.loading"
      >
        <el-table-column prop="username" label="登录名" align="center">
        </el-table-column>
        <el-table-column prop="accountBalance" label="账户余额" align="center">
        </el-table-column>
        <el-table-column prop="contactName" label="联系人" align="center">
        </el-table-column>
        <el-table-column prop="contactPhone" label="联系电话" align="center">
        </el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <el-button
              type="text"
              @click="edit(scope.row)"
              v-if="
                buttonList.includes(
                  'parkingLotList-detail-merchantTab-detail-subListTab-edit'
                )
              "
              >编辑
            </el-button>
            <el-button
              type="text"
              @click="del(scope.row.userId)"
              v-if="
                buttonList.includes(
                  'parkingLotList-detail-merchantTab-detail-subListTab-delete'
                )
              "
              >删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination
          layout="sizes, total, prev, pager, next, jumper"
          background
          :total="table.total"
          :page-size.sync="table.pageSize"
          :current-page.sync="table.page"
          @current-change="getList"
          @size-change="getList(1)"
        >
        </el-pagination>
      </div>
    </div>
    <action-dialog ref="actionDialog" :getList="getList" />
  </div>
</template>
<script>
export default {
  components: {
    actionDialog: () => import("./actionDialog.vue"),
  },
  data() {
    return {
      filtrate: {
        keyword: "",
      },

      table: {
        tableData: [],
        total: 0,
        page: 1,
        pageSize: 10,
        loading: false,
      },
    };
  },
  created() {
    this.getList();
  },
  methods: {
    edit(row) {
      this.$refs.actionDialog.userId = row.userId;
      this.$refs.actionDialog.addForm = {
        contactName: row.contactName,
        contactPhone: row.contactPhone,
        username: row.username,
      };
      this.$refs.actionDialog.show = true;
    },
    del(userId) {
      this.$confirm("此操作将永久删除该账号, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          let res = await this.$http.delete(
            `/parking/shop/sub/${userId}/delete`
          );
          if (res.code === 0) {
            this.$message.success("删除成功");
            this.getList();
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch(() => {});
    },
    reset() {
      this.filtrate = {
        keyword: "",
      };
      this.getList(1);
    },
    async getList(page = this.table.page) {
      this.table.page = page;
      try {
        this.table.loading = true;
        let res = await this.$http.post("/parking/shop/list", {
          parentUserId: this.$route.params.id,
          pageNum: page,
          pageSize: this.table.pageSize,
          keyword: this.filtrate.keyword,
        });
        if (res.code === 0) {
          for (let item of res.data.list) {
            item.createTime = this.$moment(item.createTime).format(
              "yyyy-MM-DD HH:mm:ss"
            );
          }
          this.table.tableData = res.data.list;
          this.table.total = res.data.total;
        } else {
          this.$message.error(res.msg);
        }
      } catch (err) {
        this.$message.error(err);
      } finally {
        this.table.loading = false;
      }
    },
  },
};
</script>
<style lang="scss">
#merchant-passagewayList {
  .table-container {
    .table-filtrate {
      ul {
        li {
          .addCoupon {
            background-color: #ff9747;
            border-color: #ff9747;

            i {
              font-size: 14px;
            }
          }
        }
      }
    }
  }
}
</style>
